// extracted by mini-css-extract-plugin
module.exports = {"price":"ZJ-z","onSale":"_J-z"};